// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-56b92b56] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.settings-section[data-v-56b92b56] {
  display: block;
  margin-bottom: auto;
  padding: 30px;
}
.settings-section[data-v-56b92b56]:not(:last-child) {
  border-bottom: 1px solid var(--color-border);
}
.settings-section--limit-width > *[data-v-56b92b56] {
  max-width: 900px;
}
.settings-section__name[data-v-56b92b56] {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  max-width: 900px;
  margin-top: 0;
}
.settings-section__info[data-v-56b92b56] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--default-clickable-area);
  height: var(--default-clickable-area);
  margin: calc((var(--default-clickable-area) - 16px) / 2 * -1);
  margin-inline-start: 0;
  color: var(--color-text-maxcontrast);
}
.settings-section__info[data-v-56b92b56]:hover, .settings-section__info[data-v-56b92b56]:focus, .settings-section__info[data-v-56b92b56]:active {
  color: var(--color-main-text);
}
.settings-section__desc[data-v-56b92b56] {
  margin-top: -0.2em;
  margin-bottom: 1em;
  color: var(--color-text-maxcontrast);
  max-width: 900px;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcSettingsSection-D_qeKnRb.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,qCAAqC;EACrC,6DAA6D;EAC7D,sBAAsB;EACtB,oCAAoC;AACtC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;AAClB","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-56b92b56] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.settings-section[data-v-56b92b56] {\n  display: block;\n  margin-bottom: auto;\n  padding: 30px;\n}\n.settings-section[data-v-56b92b56]:not(:last-child) {\n  border-bottom: 1px solid var(--color-border);\n}\n.settings-section--limit-width > *[data-v-56b92b56] {\n  max-width: 900px;\n}\n.settings-section__name[data-v-56b92b56] {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  font-weight: bold;\n  max-width: 900px;\n  margin-top: 0;\n}\n.settings-section__info[data-v-56b92b56] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--default-clickable-area);\n  height: var(--default-clickable-area);\n  margin: calc((var(--default-clickable-area) - 16px) / 2 * -1);\n  margin-inline-start: 0;\n  color: var(--color-text-maxcontrast);\n}\n.settings-section__info[data-v-56b92b56]:hover, .settings-section__info[data-v-56b92b56]:focus, .settings-section__info[data-v-56b92b56]:active {\n  color: var(--color-main-text);\n}\n.settings-section__desc[data-v-56b92b56] {\n  margin-top: -0.2em;\n  margin-bottom: 1em;\n  color: var(--color-text-maxcontrast);\n  max-width: 900px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
